import { Box } from "@mui/material";
import { Typography } from "../../../../../../node_modules/@mui/material/index";
import useColors from "../../../../../api/hooks/useColors";
import CustomTooltip from "../../../../../components/CustomTooltip";
import StyledDataGrid from "../../../../../components/StyledDataGrid";
import { CONTROLS_WITH_REVOKE_TOKEN_BUTTON } from "../../../../../utils/constants";
import AutoRemediationAvailableChip from "../../../../remediation/plan/components/AutoRemediationAvailableChip";
import ChipColor from "../../../../remediation/plan/components/ChipColor";
import { ReactComponent as SecurityIcon } from "../../../environment/icons/actions-scan-enabled-24.svg";
import PotentialCollapsibleSection from "./PotentialCollapsibleSection";

export const SECURITY_DATA_GRID_CLASSNAME = "security-data-grid";

export default function SecuritySection({ integrationInfo }) {
  const colors = useColors();

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 180,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
          {CONTROLS_WITH_REVOKE_TOKEN_BUTTON.includes(
            params.row.control_id
          ) && (
            <CustomTooltip title="Auto-remediation available" placement="top">
              <Box>
                <AutoRemediationAvailableChip />
              </Box>
            </CustomTooltip>
          )}
          <Typography variant="body2" color={colors.text_secondary}>
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "nist_function",
      headerName: "NIST CSF",
      flex: 0,
      width: 120,
      headerAlign: "center",
      align: "center",
      disableReorder: true,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
          <ChipColor
            value={params.value}
            style={{
              border: `1px solid ${
                colors[`nist_${params.value.toLowerCase()}_stroke`]
              }`,
              backgroundColor:
                colors[`nist_${params.value.toLowerCase()}_main`],
            }}
          />
        </Box>
      ),
    },
  ];

  return (
    <PotentialCollapsibleSection title="Security Analysis" Icon={SecurityIcon}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          padding: "0",
        }}
      >
        <div className={SECURITY_DATA_GRID_CLASSNAME}>
          <StyledDataGrid
            getRowId={(row) => row.name}
            disableColumnMenu
            columns={columns}
            rows={integrationInfo.controls}
            sortModel={[{ field: "nist_function", sort: "asc" }]}
            boxSXProps={{
              border: "none",
              boxShadow: "none",
            }}
            sx={{
              border: "none",
              boxShadow: "none",
              "& .MuiDataGrid-columnHeaders": {
                minHeight: "48px !important",
                maxHeight: "48px !important",
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: `1px solid ${colors.grey_20percent}`,
                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select":
                  {
                    fontSize: "12px",
                    fontWeight: "400",
                  },
              },
            }}
            pageSizeOptionsOverride={[5, 10, 20]}
          />
        </div>
      </div>
    </PotentialCollapsibleSection>
  );
}
